export default class BillableItemsFilter {
  customerExternalId: number;

  customerId: string;

  competence: string;

  selectedCustomerOption: string = '';

  constructor(obj: any) {
    this.customerExternalId = obj.customerExternalId || null;
    this.customerId = obj.customerId || null;
    this.competence = obj.competence || null;
  }

  static of(obj: any): BillableItemsFilter {
    return new BillableItemsFilter(obj);
  }

  static ofList(obj: any[]): BillableItemsFilter[] {
    return obj.map(this.of)
  }

  get isTradingNameFetch(): boolean {
    return this.selectedCustomerOption === 'tradingName'
  }
}
